import { Component, OnInit, Input, OnChanges } from '@angular/core';

import { InvolvementService } from '../../../services/matters/involvement.service';

declare var window: any;

@Component({
  selector: 'app-involvements',
  templateUrl: './involvements.component.html',
  styleUrls: ['./involvements.component.css'],
})
export class InvolvementsComponent implements OnInit, OnChanges {
  /**
   * Matter id from parent component
   */
  @Input() matter_id: number;

  /**
   * Matter type name from parent component, TODO: Not used in this component, check usage in other components using this component object and remove
   */
  @Input() matter_type_name: string;

  /**
   * List of all client involvements
   * @type {Array<any>}
   */
  clientInvolvements: Array<any> = [];

  /**
   * List of involvements
   * @type {Array<any>}
   */
  involvements: Array<any> = [];

  /**
   * Indicates if involvements is being loaded from the server
   * @type {boolean}
   */
  involvements_loading: boolean = true;

  /**
   * List of all roles present for the current matter
   * @type {Array<string>}
   */
  allRoles: Array<string> = [];

  /**
   * Role selected to show under "Grouped" tab in the HTML
   * @type {string}
   */
  selectedRole: string;

  /**
   * Involvements belonging to the selected role
   * @type {Array<any>}
   */
  selectedRoleInvolvements: Array<any> = [];

  /**
   * Constructor
   * @param {InvolvementService} private involvementService Service to access involvements controller in the backend
   */
  constructor(private involvementService: InvolvementService) {
    this.involvementService.involvementsComponent = this;
  }

  // Component lifecycle functions

  /**
   * Called on component initialization
   */
  ngOnInit() {}

  /**
   * Called when variables of the component change
   * @param {any} changes Angular object with variables which have changed and their current values
   */
  ngOnChanges(changes: any) {
    if (changes.matter_id && changes.matter_id.currentValue)
      setTimeout(() => {
        this.loadInvolvements();
      }, 1000);
  }

  // Component functions

  /**
   * Called when an involvement is updated or deleted so that the HTML can be updated to reflect the changes
   * @param {any}    involvement Involvement on which update or delete action has been done
   * @param {string} result      Action performed on the involvment
   */
  involvementChanged(involvement: any, result: string) {
    if (result == 'updated') {
      this.involvementService.getInvolvement(involvement.id).then((response_json) => {
        let new_involvement_object: any = response_json.involvement;
        let idx: number | undefined;
        for (let index in this.involvements) {
          if (this.involvements[Number(index)].id == involvement.id) {
            idx = Number(index);
            break;
          }
        }
        if (!(idx === undefined || idx === null)) {
          this.involvements.splice(idx, 1, new_involvement_object);
          if (involvement.roles.length < 1) involvement.roles.push('Other');
          let new_roles: any = new_involvement_object.roles;
          for (let role of new_roles) if (this.allRoles.indexOf(role) < 0) this.allRoles.push(role);
          let involvementsFound: Array<any> = [];
          for (let involvement of this.involvements) if (involvement.roles.indexOf('Client') > -1) involvementsFound.push(involvement);
          this.clientInvolvements = involvementsFound;
          this.updateRoles();
        }
      });
    } else if (result == 'deleted') {
      let idx: number | undefined;
      for (let index in this.involvements) {
        if (this.involvements[Number(index)].id == involvement.id) {
          idx = Number(index);
          break;
        }
      }
      if (idx !== undefined) {
        this.involvements.splice(idx, 1);
        let clientIdx = this.clientInvolvements.findIndex(c => c.id === involvement.id);
        if (clientIdx !== -1) {
          this.clientInvolvements.splice(clientIdx, 1);
          this.clientInvolvements = [...this.clientInvolvements];
        }
        this.updateRoles();
      }
    }
    this.involvements = [...this.involvements];
  }

  /**
   * Load involvements for the matter
   */
  loadInvolvements() {
    let scope: InvolvementsComponent = this;
    this.involvements_loading = true;
    this.involvementService.getInvolvements(this.matter_id).then((response_json) => {
      this.involvements = [];
      this.allRoles = [];
      // Only retry if response is truly undefined/null, not just empty
      // Empty array is valid (e.g., archived matters with no involvements)
      if (response_json === undefined || response_json === null) {
        console.log('Bad involvements result, loading involvements will be attempted again in 20 seconds');
        response_json = [];
        window.setTimeout(() => {
          if (scope && scope.loadInvolvements) scope.loadInvolvements();
        }, 20000);
        throw `Involvements not returned for matter id ${this.matter_id}, response JSON is undefined`;
      }
      for (let involvement of response_json) {
        if (involvement.roles.length < 1) involvement.roles.push('Other');
        this.involvements.push(involvement);
        for (let role of involvement.roles) if (this.allRoles.indexOf(role) < 0) this.allRoles.push(role);
      }
      this.allRoles.sort();
      this.selectedRole = this.allRoles[0];
      this.sortInvolvements();
      this.setInvolvementsByRole(this.selectedRole);
      let involvementsFound: Array<any> = [];
      for (let involvement of this.involvements) if (involvement.roles.indexOf('Client') > -1) involvementsFound.push(involvement);
      this.clientInvolvements = involvementsFound;
      this.involvements_loading = false;
    });
  }

  /**
   * Set involvements for the selected role
   * @param  {string}     role [description]
   * @return {Array<any>}      [description]
   */
  setInvolvementsByRole(role: string) {
    console.log('set by role')
    let involvementsFound: Array<any> = [];
    for (let involvement of this.involvements) if (involvement.roles.indexOf(role) > -1) involvementsFound.push(involvement);
    this.selectedRole = role;
    console.log(role, involvementsFound)
    this.selectedRoleInvolvements = involvementsFound;
  }

  /**
   * Sort involvements by name
   */
  sortInvolvements() {
    this.involvements.sort((a, b) => {
      let a_last_name_first = String(a.last_name_first).toUpperCase();
      let b_last_name_first = String(b.last_name_first).toUpperCase();
      if (a_last_name_first < b_last_name_first) return -1;
      else if (a_last_name_first > b_last_name_first) return 1;
      else return 0;
    });
  }

  /**
   * Update list of all roles when an involvement has been added, updated or deleted
   */
  updateRoles() {
    console.log('updating roles')
    let allNewRoles: Array<any> = [];
    for (let involvement of this.involvements) {
      for (let role of involvement.roles) if (allNewRoles.indexOf(role) < 0) allNewRoles.push(role);
    }
    allNewRoles.sort();
    this.allRoles = allNewRoles;
    if (this.selectedRole && this.allRoles.length > 0 && this.allRoles.indexOf(this.selectedRole) < 0) {
      this.selectedRole = this.allRoles[0];
      this.setInvolvementsByRole(this.selectedRole);
    }else if(this.selectedRole){
      this.setInvolvementsByRole(this.selectedRole);
    }
  }
}
